/**
 * Widget type enum (matches DB WidgetType).
 * Display names for cards selection and labels.
 */
export const WIDGET_TYPES = [
  'barchart',
  'linechart',
  'piechart',
  'kpi',
  'recommendation',
  'major_issues',
  'summary',
  'success',
  'custom_ai_card',
];

export const ENUM_TO_DISPLAY = {
  barchart: 'Build Bar Chart',
  linechart: 'Build Line Chart',
  piechart: 'Build Pie Chart',
  kpi: 'KPI',
  recommendation: 'AI Recommendation',
  major_issues: 'Analyze Major Issues',
  summary: 'Summarize Data',
  success: 'Success Factors',
  custom_ai_card: 'Custom AI Card',
};

/** Map legacy/UI values to enum when reading from API */
const LEGACY_TO_ENUM = {
  chart: 'barchart',
  bar_chart: 'barchart',
  bar: 'barchart',
  line_chart: 'linechart',
  line: 'linechart',
  pie_chart: 'piechart',
  pie: 'piechart',
  analysis: 'major_issues',
  major_issues: 'major_issues',
  recommendation: 'recommendation',
  summary: 'summary',
  success: 'success',
  custom_ai_card: 'custom_ai_card',
  kpi: 'kpi',
};

/** Sidebar popup id (CardsPage) for each enum type */
export const ENUM_TO_POPUP_ID = {
  barchart: 6,
  linechart: 9,
  piechart: 7,
  kpi: 8,
  recommendation: 2,
  major_issues: 3,
  summary: 1,
  success: 4,
  custom_ai_card: 5,
};

export function toEnum(raw) {
  if (!raw) return 'barchart';
  const key = String(raw).trim().toLowerCase();
  return LEGACY_TO_ENUM[key] || (WIDGET_TYPES.includes(key) ? key : 'barchart');
}

export function toDisplay(enumVal) {
  if (!enumVal) return 'Widget';
  const e = String(enumVal).trim().toLowerCase();
  return ENUM_TO_DISPLAY[e] || e.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Display name -> enum for resolving popup when only cardType (display) is available */
const DISPLAY_TO_ENUM = Object.fromEntries(
  Object.entries(ENUM_TO_DISPLAY).map(([k, v]) => [v.toLowerCase().trim(), k])
);

/** Resolve widget type (or chartType for legacy) to popup id for Edit/Add */
export function getPopupIdFromWidgetType(widgetType, chartType) {
  const w = (widgetType ?? '').toString().toLowerCase().trim();
  const c = (chartType ?? '').toString().toLowerCase().trim();
  // Prefer enum from display name (e.g. "AI Recommendation" -> recommendation) when toEnum would default to barchart
  const enumFromDisplay = DISPLAY_TO_ENUM[w];
  const enumVal = toEnum(enumFromDisplay || w || (c === 'pie' ? 'piechart' : c === 'bar' ? 'barchart' : ''));
  return ENUM_TO_POPUP_ID[enumVal] ?? (c === 'pie' ? 7 : 6);
}
